export const FORM_MUTATION = gql`
    mutation sendLead($event_type: String!, $mail_title: String!, $fields: [InputLeadField]) {
        sendLead(lead: { type: $event_type, name: $mail_title, fields: $fields })
    }
`
